import React from 'react';

let ImagenSonda = React.createContext([]);
let ImagenEco = React.createContext([]);

export { ImagenSonda, ImagenEco };